export default "__VITE_PUBLIC_ASSET__6756acb0__"